export const RoomEmptyTestIds = {
  containerEmptychat: 'container_emptychat',
  containerEmptychatmessage: 'container_emptychatmessage'
} as const;
